import React, {Component} from 'react';
import {Container, Menu, Dropdown, Form, Button} from 'semantic-ui-react';
import {LOCAL_ENDPOINTS} from '../config';
import axios from 'axios';
import {options, formatDate} from '../Utility/helpers';
import {TableConstructor} from '../Components/TableConstructor';

import "./Constants.css";

class TenantProfile extends Component {
  constructor(props){
    super(props);
    this.state = {
      tenantId: this.props.match.params.tenantId,
      tenant: {
        Addresses: []
      },      
      invoices: [],
      manual_journals: [],
      bank_transactions: [],
      organisations: [],
      
      journals: [],
      credit_notes: [],
      payments: [],
      
      export_options: [],
      access_token: localStorage.getItem("access_token"),
      start_date: formatDate(new Date()),
      end_date: formatDate(new Date()),
      activeItem: 'Invoices',
      activeHeader: 'invoices',
    }

    this.fetchBankTransactions = this.fetchBankTransactions.bind(this);
    this.fetchCreditNotes = this.fetchCreditNotes.bind(this);
    this.fetchInvoices = this.fetchInvoices.bind(this);
    this.fetchJournals = this.fetchJournals.bind(this);
    this.fetchManualJournals = this.fetchManualJournals.bind(this);
    this.fetchPayments = this.fetchPayments.bind(this);

    this.downloadCSV = this.downloadCSV.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleExportOptions = this.handleExportOptions.bind(this);

    this.handleItemClick = this.handleItemClick.bind(this);
  }

  componentDidMount = async () => {

    const {tenantId, access_token} = this.state;
    let tenant = await axios({method: "GET", url: LOCAL_ENDPOINTS.getOrganisationName, headers: {"Authorization": "Bearer " + access_token, "Xero-tenant-id": tenantId}})
    this.setState({tenant: tenant.data.Organisations[0]});

    let invoices = await this.fetchInvoices();
    let credit_notes = await this.fetchCreditNotes();
    let journals = await this.fetchJournals();
    let manual_journals = await this.fetchManualJournals();
    let bank_transactions = await this.fetchBankTransactions();
    let payments = await this.fetchPayments();

    this.setState({
      bank_transactions, credit_notes, invoices, journals, manual_journals, payments,
      organisations: [this.state.tenant]
    })
  }

  fetchBankTransactions = () => {
    const {access_token, tenantId} = this.state;
    return axios({
      method: "POST",
      url: LOCAL_ENDPOINTS.getBankTransactions,
      headers: {"Authorization": "Bearer " + access_token, "Accept": "application/json", "Xero-tenant-id": tenantId},
    })
    .then(result => {
      return result.data.BankTransactions;
    })
  }

  fetchCreditNotes = () => {
    const {access_token, tenantId} = this.state;
    return axios({
      method: "POST",
      url: LOCAL_ENDPOINTS.getCreditNotes,
      headers: {"Authorization": "Bearer " + access_token, "Accept": "application/json", "Xero-tenant-id": tenantId},
    })
    .then(result => {
      return result.data.CreditNotes;
    })
  }

  fetchInvoices = () => {
    const {access_token, tenantId} = this.state;
    return axios({
      method: "POST",
      url: LOCAL_ENDPOINTS.getInvoices,
      headers: {"Authorization": "Bearer " + access_token, "Accept": "application/json", "Xero-tenant-id": tenantId},
    })
    .then(result => {
      return result.data.Invoices;
    })
  }
  
  fetchJournals = () => {
    const {access_token, tenantId} = this.state;
    return axios({
      method: "POST",
      url: LOCAL_ENDPOINTS.getJournals,
      headers: {"Authorization": "Bearer " + access_token, "Accept": "application/json", "Xero-tenant-id": tenantId},
    })
    .then(result => {
      return result.data.Journals;
    })
  }

  fetchManualJournals = () => {
    const {access_token, tenantId} = this.state;
    return axios({
      method: "POST",
      url: LOCAL_ENDPOINTS.getManualJournals,
      headers: {"Authorization": "Bearer " + access_token, "Accept": "application/json", "Xero-tenant-id": tenantId},
    })
    .then(result => {
      return result.data.ManualJournals;
    })
  }

  fetchPayments = () => {
    const {access_token, tenantId} = this.state;
    return axios({
      method: "POST",
      url: LOCAL_ENDPOINTS.getPayments,
      headers: {"Authorization": "Bearer " + access_token, "Accept": "application/json", "Xero-tenant-id": tenantId},
    })
    .then(result => {
      return result.data.Payments;
    })
  }

  downloadCSV = () => {
    let {tenant, start_date, end_date, export_options, access_token} = this.state;
    let tenants_from_xero = [{
      tenantId: tenant.OrganisationID,
      tenantType: tenant.OrganisationType,
      organisationName: tenant.LegalName,
    }];

    start_date = new Date(start_date);
    end_date = new Date(end_date);

    if(export_options.length === 0){
      alert("Input export options first!");
    }else{
      if(start_date < end_date){
        let unencoded = `Date >= DateTime(${start_date.getFullYear()}, ${start_date.getMonth()+1}, ${start_date.getDate()}) && Date < DateTime(${end_date.getFullYear()}, ${end_date.getMonth()+1}, ${end_date.getDate()})`
        let date_params = encodeURIComponent(unencoded)
        
        export_options.map(async option => {
          await axios({
            method: "POST",
            url: LOCAL_ENDPOINTS[option],
            headers: {"Authorization": "Bearer " + access_token},
            data: {
              date_params,
              tenants_from_xero,
            }
          })
        })
      }else{
        alert("Start date cannot be further than end date!")
      }
    }
  }
  
  handleChange = e =>{
    const target = e.target;
    const value = (target.value);
    const name = target.name;

    this.setState({
        [name]: value
    });
  }

  handleChangeStartDate = date => {
    this.setState({
      start_date: date
    })
  }

  handleChangeEndDate = date => {
    this.setState({
      end_date: date
    })
  }

  handleItemClick = (e, {name, target}) => {
    this.setState({activeItem: name, activeHeader: target});
  }

  handleExportOptions = (e, data) => {
    this.setState({
      export_options: data.value
    })
  }

  render(){
    let {tenant, activeItem, activeHeader} = this.state;
    let table_data = TableConstructor(activeHeader, this.state[activeHeader]);

    return(
      <div>
        <Container>
          <div className="organisation-title">
            <h2>{tenant.LegalName}</h2>
            <p>{
                (tenant.Addresses.length === 0)?
                  "No registered addresses":
                  `${tenant.Addresses[0].AddressLine1}, ${tenant.Addresses[0].AddressLine2}, ${tenant.Addresses[0].City}, ${tenant.Addresses[0].PostalCode}`
              }</p>
            <p>Currency: {tenant.BaseCurrency}</p>
          </div>

          <hr></hr>

          <div className="accounting-view">
            <div className="accounting-menu">
              <Menu vertical>
                <Menu.Item>
                  <Menu.Header>
                    Accounting
                    <Menu.Menu>
                      <Menu.Item
                        name="Bank Transactions"
                        target="bank_transactions"
                        active={activeItem === 'Bank Transactions'}
                        onClick={this.handleItemClick}
                      />

                      <Menu.Item
                        name="Credit Notes"
                        target="credit_notes"
                        active={activeItem === 'Credit Notes'}
                        onClick={this.handleItemClick}
                      />

                      <Menu.Item
                        name="Invoices"
                        target="invoices"
                        active={activeItem === 'Invoices'}
                        onClick={this.handleItemClick}
                      />

                      <Menu.Item
                        name="Journals"
                        target="journals"
                        active={activeItem === 'Journals'}
                        onClick={this.handleItemClick}
                      />

                      <Menu.Item
                        name="Manual Journals"
                        target="manual_journals"
                        active={activeItem === 'Manual Journals'}
                        onClick={this.handleItemClick}
                      />

                      <Menu.Item
                        name="Organisations"
                        target="organisations"
                        active={activeItem === 'Organisations'}
                        onClick={this.handleItemClick}
                      />

                      <Menu.Item
                        name="Payments"
                        target="payments"
                        active={activeItem === 'Payments'}
                        onClick={this.handleItemClick}
                      />
                    </Menu.Menu>
                  </Menu.Header>
                </Menu.Item>
              </Menu>
            </div>
            
            <div className="accounting-table">
              {table_data}
            </div>
          </div>

          <div>
            <p>*Displaying 10 results only</p>
          </div>

          <div className="export-settings">
              <Dropdown placeholder="Select data to export" fluid multiple selection options={options} value={this.state.export_options} onChange={this.handleExportOptions}></Dropdown>
              <div className="export-filters">

                <div>
                  <Form.Input type="Date" label="Start date" value={this.state.start_date} onChange={this.handleChange} name="start_date"></Form.Input>
                </div>
                <div>
                  <Form.Input type="Date" label="End date" value={this.state.end_date} onChange={this.handleChange} name="end_date"></Form.Input>
                </div>
                <div>
                  <Button className="export-button" color="green" onClick={this.downloadCSV} disabled>EXPORT</Button>
                </div>
              </div>
            </div>
        </Container>
      </div>
    )
  }
}

export default TenantProfile;